import React from 'react'

import { Column } from 'primereact/column'

import { PanelContainer } from '../../../../components/Panel'
import {
  AttachmentDownloadButton,
  AttachmentOpenInTabButton,
} from '../../../../components/attachments'
import { Attachment as AttachmentModel } from '../../../../data/models'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { ConfigurableTable } from '../../../../utils/wrapper'
import { useConfigContext } from '../../../ui-config'
import { useOrder } from '../../data'

interface Props {
  id: string
}

export const Attachment: React.FC<Props> = ({ id }) => {
  const { data, isLoading } = useOrder(id)
  const { uiConfig: config } = useConfigContext()

  // get only the order attachments
  const orderAttachment = data?.Attachments.filter(
    item => item.Type.toLowerCase() === 'order',
  )
  // get all other attachments
  const otherAttachments = data?.Attachments.filter(
    item => item.Type.toLowerCase() === 'additional',
  )

  const actionBodyTemplate = (rowData: AttachmentModel) => {
    return (
      <>
        <AttachmentOpenInTabButton
          key={`att-tab-${rowData.Id}`}
          fullUrl={rowData.Url as string}
          mimeType={rowData.MimeType as string}
          fileName={rowData.Name}
        />

        <AttachmentDownloadButton
          key={`att-download-${rowData.Id}`}
          fullUrl={rowData.Url as string}
          mimeType={rowData.MimeType as string}
          fileName={rowData.Name}
        />
      </>
    )
  }
  const attachmentButtons = (
    <Column
      key="attachmentButtons"
      body={actionBodyTemplate}
      align="right"
    ></Column>
  )

  return (
    <PanelContainer
      header={getConfigTranslation(config.orderResponse.attachment.title)}
      id="order-attachment"
      visible={config.orderResponse.attachment.enabled}
    >
      <>
        {/* documents */}
        <ConfigurableTable
          config={config.orderResponse.attachment.documents}
          data={orderAttachment}
          buttons={attachmentButtons}
          isLoading={isLoading}
          stateKey=""
        />

        {/* additional documents */}
        <ConfigurableTable
          config={config.orderResponse.attachment.additionalDocuments}
          data={otherAttachments}
          buttons={attachmentButtons}
          isLoading={isLoading}
          stateKey=""
        />
      </>
    </PanelContainer>
  )
}
